import React from "react";
import formatCurrency from "@tvg/formatter/currency";
import { Paragraph, Button } from "@tvg/design-system";
import { TextContainer } from "../PlaceBetButton/styled-components";

export interface InsufficientFundsButtonProps {
  onClickInsufficientFunds: () => void;
  placeAmount: number;
}

const InsufficientFundsButton = ({
  onClickInsufficientFunds,
  placeAmount
}: InsufficientFundsButtonProps) => (
  <Button
    ml="space-4"
    paddingX="space-8"
    variant="primary"
    onPress={onClickInsufficientFunds}
    qaLabel="bet-slip-deposit-button"
  >
    <TextContainer>
      <Paragraph
        fontFamily="bold"
        fontSize="s"
        color="white.900"
        qaLabel="bet-slip-deposit-text"
      >
        Deposit Now
      </Paragraph>
      <Paragraph
        fontFamily="condensedRegular"
        fontSize="xs"
        textTransform="uppercase"
        color="white.900"
        qaLabel="bet-slip-insufficient-funds-text"
      >
        {`${formatCurrency(placeAmount)} Bet`}
      </Paragraph>
    </TextContainer>
  </Button>
);

export default InsufficientFundsButton;
